"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _router = require("@reach/router");

var _antd = require("antd");

var _BaseLayout = _interopRequireDefault(require("../components/BaseLayout"));

var _Edges = _interopRequireDefault(require("../components/Edges"));

var _SiteForm = _interopRequireDefault(require("../components/SiteForm"));

var _ListItem = _interopRequireDefault(require("../components/ListItem"));

var _Loader = _interopRequireDefault(require("../components/Loader"));

var _actions = require("../actions");

var _store = require("../store");

var _routes = _interopRequireDefault(require("../routes")); // import app components


var Home = function Home() {
  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      config = _ref2$.config,
      sites = _ref2$.cmsState.sites,
      dispatch = _ref2[1];

  var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      loaded = _ref4[0],
      setLoaded = _ref4[1];

  (0, _react.useEffect)(function () {
    var loadSites = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!config.multisite) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _actions.siteActions.getSites({}, dispatch, config);

              case 3:
                _context.next = 6;
                break;

              case 5:
                (0, _router.navigate)((0, _routes.default)("dashboard"));

              case 6:
                setLoaded(true);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function loadSites() {
        return _ref5.apply(this, arguments);
      };
    }();

    loadSites();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loaded ? /*#__PURE__*/_react.default.createElement(_BaseLayout.default, null, /*#__PURE__*/_react.default.createElement(_Edges.default, {
    size: "md"
  }, /*#__PURE__*/_react.default.createElement(_antd.PageHeader, {
    title: "My Websites",
    extra: [/*#__PURE__*/_react.default.createElement(_antd.Button, {
      key: "1",
      onClick: function onClick() {
        return dispatch({
          type: 'SET_DIALOG',
          payload: {
            open: true,
            title: 'Add Website',
            component: /*#__PURE__*/_react.default.createElement(_SiteForm.default, null)
          }
        });
      },
      type: "primary",
      children: "Add Site"
    })]
  }), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, Object.keys(sites).map(function (key) {
    var _sites$key = sites[key],
        id = _sites$key.id,
        title = _sites$key.title;
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      key: id,
      title: title,
      actions: [/*#__PURE__*/_react.default.createElement(_antd.Button, {
        key: "1",
        onClick: function onClick() {
          return (0, _router.navigate)((0, _routes.default)("dashboard", {
            siteID: id
          }));
        },
        children: "Dashboard"
      })],
      link: (0, _routes.default)("dashboard", {
        siteID: id
      })
    });
  })))) : /*#__PURE__*/_react.default.createElement(_Loader.default, null));
};

var _default = Home;
exports.default = _default;